<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.Menus.Logs }}
            <span class="subtitle hero-subtitle">{{ $lang.Menus.LogState }}</span>

            <p v-if="backBtnActive == true" class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="section is-main-section table-page">
            <div v-if="$store.state.memberId != 'TestMember' && $store.state.isAdmin == 1" class="filter-card">
                <p class="member-heading">{{ $lang.AdminExcel.Title_1 }}</p>
                <div class="filter-row is-wide-dates">
                    <b-field :label="$lang.AdminExcel.FirstDate">
                        <b-datetimepicker v-model="firstDate"
                                          rounded
                                          icon="calendar-today"
                                          :icon-right="firstDate ? 'close-circle' : ''"
                                          icon-right-clickable
                                          @icon-right-click="clearDateTime_1"
                                          :locale="dateLocale"
                                          :datetime-formatter="formatDateTime"
                                          :first-day-of-week="1">
                        </b-datetimepicker>
                    </b-field>
                    <b-field :label="$lang.AdminExcel.SecondDate">
                        <b-datetimepicker v-model="secondDate"
                                          rounded
                                          icon="calendar-today"
                                          :icon-right="secondDate ? 'close-circle' : ''"
                                          icon-right-clickable
                                          @icon-right-click="clearDateTime_2"
                                          :locale="dateLocale"
                                          :datetime-formatter="formatDateTime"
                                          :first-day-of-week="1">
                        </b-datetimepicker>
                    </b-field>
                    <div class="filter-actions">
                        <b-button @click="getLogsTable2">{{ $lang.AdminExcel.ListProjects }}</b-button>
                    </div>
                </div>
            </div>

            <!-- Widths: the six names share what is left; No, IP and Tarih are fixed. -->
            <b-table class="data-table is-sticky-lead"
                     style="--table-min: 1320px"
                     :data="logsdata"
                     :loading="isLoading"
                     :mobile-sort-placeholder="$lang.MyProjects.SortBy"
                     :paginated="isPaginated"
                     :per-page="perPage"
                     hoverable>
                <b-table-column field="FullName" :label="$lang.AdminExcel.UserName" v-slot="props" searchable cell-class="cell-strong m-title">
                    {{ props.row.FullName }}
                </b-table-column>
                <b-table-column field="LastUserName" :label="$lang.ProjectInfos.LastUserName" v-slot="props" searchable>
                    {{ props.row.LastUserName }}
                </b-table-column>
                <b-table-column field="PanelManifacturer" :label="$lang.ProjectInfos.PanelManifacturer" v-slot="props" searchable>
                    {{ props.row.PanelManifacturer }}
                </b-table-column>
                <b-table-column field="Title" :label="$lang.Member.Title" v-slot="props" searchable cell-class="m-full">
                    {{ props.row.Title }}
                </b-table-column>
                <b-table-column field="ProjectName" :label="$lang.AdminExcel.ProjectName" v-slot="props" searchable>
                    {{ props.row.ProjectName }}
                </b-table-column>
                <b-table-column field="PanelName" :label="$lang.AdminExcel.PanelName" v-slot="props" searchable>
                    {{ props.row.PanelName }}
                </b-table-column>
                <b-table-column field="PanelNo" :label="$lang.AdminExcel.PanelNo" v-slot="props" width="88" searchable numeric>
                    {{ props.row.PanelNo }}
                </b-table-column>
                <b-table-column field="IP" :label="$lang.AdminExcel.IP" v-slot="props" width="184" searchable>
                    {{ props.row.IP }}
                </b-table-column>
                <!-- AcceptDate arrives as "MM/dd/yyyy HH:mm:ss"; shown dd-mm-yyyy hh:mm, sorted as a date. -->
                <b-table-column field="AcceptDate" :label="$lang.AdminExcel.Date" v-slot="props" width="166" numeric sortable :custom-sort="sortByAcceptDate" cell-class="m-sub">
                    {{ formatAcceptDate(props.row.AcceptDate) }}
                </b-table-column>

                <template #empty>
                    <!-- Rows loaded but none shown: the column search filtered them all out. -->
                    <p v-if="!isLoading" class="table-empty">{{ logsdata.length ? $lang.AdminExcel.NoMatch : $lang.AdminExcel.EmptyLogs }}</p>
                </template>

                <template #bottom-left>
                    {{ logsdata.length }} {{ $lang.AdminExcel.LogCountSuffix }}
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';

    export default {
        name: 'AcceptLogs',
        data() {
            return {
                isActive: true,
                isLoading: false,
                firstDate: new Date(),
                secondDate: new Date(),
                showWeekNumber: false,
                enableSeconds: false,
                hourFormat: undefined, // Browser locale
                firstDayOfWeek: undefined, // 0 - Sunday
                isPaginated: true,
                perPage: 10,
                logsdata: [],
                backBtnActive: false
            }
        },
        computed: {
            dateLocale() {
                return this.$lang.Format.Lang === 'tr-TR' ? 'tr-TR' : 'en-GB';
            }
        },
        mounted() {
            if (this.$store.state.previousRoute == 'projectInfos' || this.$store.state.previousRoute == 'panelInfos' || this.$store.state.previousRoute == 'envConditions' ||
                this.$store.state.previousRoute == 'calc_Busbar' || this.$store.state.previousRoute == 'calc_InputCircuit' || this.$store.state.previousRoute == 'calc_OutputCircuit' ||
                this.$store.state.previousRoute == 'calc_Manuel' || this.$store.state.previousRoute == 'calc_Summary' || this.$store.state.previousRoute == 'results' ||
                this.$store.state.previousRoute == 'reportPdfPage' || this.$store.state.previousRoute == 'calculation') {
                this.backBtnActive = true;
            } else {
                this.backBtnActive = false;
            }
            this.getLogsTable();

            this.$store.state.isFooterFixed = true;
        },
        destroyed() {
            this.$store.state.isFooterFixed = false;
        },
        methods: {
            getLogsTable() {
                this.isLoading = true;
                this.logsdata = [];               
                api.panels.getAcceptLogs().then((res) => {
                    this.isLoading = false;
                    if (!res || res.isError) {
                        console.log("error ");
                    } else {
                        res.data.forEach((e) => {
                            this.logsdata.push(e);
                        });
                    }
                });
            },
            getLogsTable2() {
                this.isLoading = true;
                this.logsdata = [];
                var first = this.formatDate(this.firstDate).toString();
                var second = this.formatDate(this.secondDate).toString();
                api.panels.getAcceptLogs2(first, second).then((res) => {
                    this.isLoading = false;
                    if (!res || res.isError) {
                        console.log("error ");
                    } else {
                        res.data.forEach((e) => {
                            this.logsdata.push(e);
                        });
                    }
                });
            },

            clearDateTime_1() {
                this.firstDate = null
            },
            clearDateTime_2() {
                this.secondDate = null
            },
            formatDate(date) {
                const year = date.toLocaleString('default', { year: 'numeric' });
                const month = date.toLocaleString('default', {
                    month: '2-digit',
                });
                const day = date.toLocaleString('default', { day: '2-digit' });

                return [year, month, day].join('-');
            },

            columnTdAttrs(row, column) {
                if (row.id === 'Total') {
                    if (column.label === 'ID') {
                        return {
                            colspan: 4,
                            class: 'has-text-weight-bold',
                            style: {
                                'text-align': 'left !important'
                            }
                        }
                    } else if (column.label === 'Gender') {
                        return {
                            class: 'has-text-weight-semibold'
                        }
                    } else {
                        return {
                            style: { display: 'none' }
                        }
                    }
                }
                return null
            },
            // The API sends "MM/dd/yyyy HH:mm:ss", which as text sorts by month and day
            // with the years mixed; compare the dates themselves.
            sortByAcceptDate(a, b, isAsc) {
                const time = (row) => new Date(row.AcceptDate).getTime() || 0;
                return isAsc ? time(a) - time(b) : time(b) - time(a);
            },
            formatDateTime(date) {
                const two = (n) => ('0' + n).slice(-2);
                return two(date.getDate()) + '-' + two(date.getMonth() + 1) + '-' + date.getFullYear() +
                    ' ' + two(date.getHours()) + ':' + two(date.getMinutes());
            },
            formatAcceptDate(value) {
                if (!value) {
                    return '-';
                }
                const date = new Date(value);
                return isNaN(date) ? value : this.formatDateTime(date);
            },
            previous() {
                router.push('/' + this.$store.state.previousRoute);
            }
        }
    };
</script>
